import React from "react";

import { IGatsbyImageData } from "gatsby-plugin-image";

import ProductImage from "./productImage";

import { __t } from "../../utils/translate";

type CarouselItemProps = {
    imageData: IGatsbyImageData;
    alt: string;
    idx: number;
    loading?: string;
    decoding?: string;
    className?: string;
    isFullScreen?: boolean;
};

const CarouselItem: React.FC<CarouselItemProps> = ({ imageData, alt, idx, loading = "lazy", decoding = "async", className = "", isFullScreen }) => {
    return (
        <ProductImage
            className={`${className}  object-cover
            ${isFullScreen ? 'max-w-[90vh] w-fit ' : 'w-full lg:mr-[0px] lg-hero:mr-[36px] lg-hero:w-[450px] lg-hero:h-[450px]'} aspect-square`}
            loading={loading}
            decoding={decoding}
            imageData={imageData}
            alt={alt}
        />
    );
};

export default CarouselItem;